export const CAMPAIGN_LIVE_POLL_INTERVAL_MS = 5_000;
export const CAMPAIGN_DUE_SOON_WINDOW_MS = 30_000;
export const CAMPAIGN_MAX_SCHEDULE_CHECK_INTERVAL_MS = 60_000;

const LIVE_CAMPAIGN_STATUSES = new Set(["queued", "processing", "pausing", "paused_limit"]);

export function getCampaignsRefetchInterval(campaigns, now = Date.now()) {
  const campaignList = Array.isArray(campaigns) ? campaigns : [];

  if (campaignList.some((campaign) => LIVE_CAMPAIGN_STATUSES.has(campaign?.status))) {
    return CAMPAIGN_LIVE_POLL_INTERVAL_MS;
  }

  const scheduledSendTimes = campaignList
    .filter((campaign) => campaign?.status === "scheduled" && campaign?.send_mode === "scheduled")
    .map((campaign) => new Date(campaign.scheduled_send_at).getTime())
    .filter(Number.isFinite);

  if (scheduledSendTimes.length === 0) {
    return false;
  }

  const nextScheduledSendAt = Math.min(...scheduledSendTimes);
  const millisecondsUntilDue = nextScheduledSendAt - now;

  if (millisecondsUntilDue <= CAMPAIGN_DUE_SOON_WINDOW_MS) {
    return CAMPAIGN_LIVE_POLL_INTERVAL_MS;
  }

  return Math.min(
    millisecondsUntilDue - CAMPAIGN_DUE_SOON_WINDOW_MS,
    CAMPAIGN_MAX_SCHEDULE_CHECK_INTERVAL_MS,
  );
}
